import { useMemo } from 'react'
import cn from 'clsx'

const IconToggle = ({
    className,
    iconClassName,
    onIconClassName,
    offIconClassName,
    checked = false,
    onChange,
    OnIcon,
    OffIcon,
    rotate = false,
    ...props
}) => {
    
    const classes = useMemo(() => ({
        'swap-rotate': rotate,
    }), [
        rotate,
    ])
    
    return (
        
        <label
            className={cn('IconToggle swap', className, classes)}
            {...props}>
            
            {/* this hidden checkbox controls the state */}
            <input
                className="hidden"
                type="checkbox"
                checked={checked}
                onChange={onChange} />
            
            <OnIcon className={cn('swap-on', iconClassName, onIconClassName)} />
            
            <OffIcon className={cn('swap-off', iconClassName, offIconClassName)} />
        
        </label>
        
    )
    
}

export default IconToggle
